import { useState } from 'react';
import PropTypes from 'prop-types';

import { buttonStyle, buttonOpen, revealStyle, revealWrapper } from './styles.module.scss';

export const Reveal = ({ label, children }) => {
  const [isVisible, setVisibility] = useState(false);
  const classes = isVisible ? buttonOpen : buttonStyle;
  return (
    <div className={revealWrapper}>
      <button
        className={classes}
        onClick={() => setVisibility(!isVisible)}
        aria-expanded={isVisible}
      >
        {label}
      </button>
      {isVisible && <div className={revealStyle}>{children}</div>}
    </div>
  );
};

Reveal.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired
};
